<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.aa_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="aa_date">
            <label class="weui-form-preview__label">{{
              customLabel.aa_date || "调账日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.aa_date, 'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_currency">
            <label class="weui-form-preview__label">{{
              customLabel.aa_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.aa_currency }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_name">
            <label class="weui-form-preview__label">{{
              customLabel.cu_name || "客户名称"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.cu_name
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="aa_beforeamount">
            <label class="weui-form-preview__label">{{
              customLabel.aa_beforeamount || "调账前金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.aa_beforeamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_afteramount">
            <label class="weui-form-preview__label">{{
              customLabel.aa_afteramount || "调账后金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.aa_afteramount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_amount">
            <label class="weui-form-preview__label">{{
              customLabel.aa_amount || "调账金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.aa_amount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_principle">
            <label class="weui-form-preview__label">{{
              customLabel.aa_principle || "分摊原则"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_principle
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_remark">
            <label class="weui-form-preview__label">{{
              customLabel.aa_remark || "调账原因"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_orcode">
            <label class="weui-form-preview__label">{{
              customLabel.aa_orcode || "调账单号"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.aa_orcode }}
            </span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pp_text1 || '自定义字段1'"
          v-model="form.main.pp_text1" slot="pp_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text2 || '自定义字段2'"
          v-model="form.main.pp_text2" slot="pp_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text3 || '自定义字段3'"
          v-model="form.main.pp_text3" slot="pp_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text4 || '自定义字段4'"
          v-model="form.main.pp_text4" slot="pp_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text5 || '自定义字段5'"
          v-model="form.main.pp_text5" slot="pp_text5" hidden="true" />
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ad_sourcedetno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ad_sourcecode">
              <label class="weui-form-preview__label">{{
                customLabel.ad_sourcecode || "来源单号"
              }}</label>
              <span class="weui-form-preview__value">{{parseInOutType(item.ad_sourcetype)}} {{
                item.ad_sourcecode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ad_sourcedetno">
              <label class="weui-form-preview__label">{{
                customLabel.ad_sourcedetno || "来源单行号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.ad_sourcedetno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ad_sourceamount">
              <label class="weui-form-preview__label">{{
                customLabel.ad_sourceamount || "来源单金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ad_sourceamount, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ad_sourceqty">
              <label class="weui-form-preview__label">{{
                customLabel.ad_sourceqty || "来源单数量"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.ad_sourceqty }} {{ item.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ad_amount">
              <label class="weui-form-preview__label">{{
                customLabel.ad_amount || "调账金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ad_amount, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_code">
              <label class="weui-form-preview__label">{{
                customLabel.pr_code || "物料编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_code
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "物料名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_spec
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ppd_text1 || '自定义字段1'"
            v-model="item.ppd_text1" slot="ppd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text2 || '自定义字段2'"
            v-model="item.ppd_text2" slot="ppd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text3 || '自定义字段3'"
            v-model="item.ppd_text3" slot="ppd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text4 || '自定义字段4'"
            v-model="item.ppd_text4" slot="ppd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text5 || '自定义字段5'"
            v-model="item.ppd_text5" slot="ppd_text5" hidden="true" />
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.aa_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_auditman
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";
import Collapse from "@/components/Collapse.vue";
import Biz from "@/util/biz.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField,
    Collapse
  },
  data() {
    return {
      baseUrl: "/api/money/araccountapply",
      caller: "ArAccountApply",
      xtype: "money-araccountapply-formpanel",
    };
  },
  methods: {
    parseInOutType(type) {
      return Biz.parseInOutType(type)
    }
  }
};
</script>